import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import theme from '../../../styles/theme';

const StyledInput = styled.input`
  display: block;
  height: ${({ size }) => theme.inputSizes[size]};
  box-sizing: border-box;
  padding: 0 ${theme.spacing.s};
  border-radius: ${theme.surface.borderRadius};
  border: 2px solid transparent;
  font-family: ${theme.fontStyles.family};
  font-size: ${theme.spacing.s};
  background-color: ${theme.colors.gray100};
  color: ${theme.colors.fontBase};
  outline: none;

  &::placeholder {
    color: ${theme.colors.placeholder};
  }

  &:hover {
    transition: background-color 0.2s;
    background-color: ${theme.colors.bgInputHover};
  }

  &:focus {
    background-color: ${theme.colors.white};
    border-color: ${theme.colors.bgInputHover};
  }

  &:disabled,
  &:disabled:hover {
    cursor: not-allowed;
    background-color: ${theme.colors.gray200};
    transition: none;
  }

  &.error {
    background-color: ${theme.colors.white};
    border-color: ${theme.colors.error};
  }

  &.success {
    background-color: ${theme.colors.white};
    border-color: ${theme.colors.success};
  }
`;

const Input = ({
  width,
  isFullWidth,
  size,
  onChange,
  name,
  error,
  success,
  ...props
}) => {
  const inputStyle = {
    width: isFullWidth ? `100%` : `${width}px`,
  };

  let status = '';

  if (error) {
    status = 'error';
  }
  if (success) {
    status = 'success';
  }

  return (
    <StyledInput
      onChange={onChange}
      name={name}
      size={size}
      className={status || undefined}
      {...props}
      style={{ ...props.style, ...inputStyle }}
    />
  );
};

Input.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  isFullWidth: PropTypes.bool,
  onChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['base', 'sm']),
  error: PropTypes.bool,
  success: PropTypes.bool,
  style: PropTypes.object,
};

Input.defaultProps = {
  width: theme.colors.defaultWidth,
  isFullWidth: false,
  onChange: () => {},
  size: 'base',
  error: false,
  success: false,
  style: {},
};

export default Input;
